"use client"

import { Button } from "@/components/Button/Button";
import useCartStore from '@/store/useCartStore';
import { formatPrice } from '@/utils/pricingUtils';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import styles from './CartOrderSummary.module.scss';

export function CartOrderSummary() {

  const router = useRouter();

  const cartLoading = useCartStore(state => state.cartLoading);
  const cartMetaTotalCount = useCartStore(state => state.cartMetaTotalCount);
  const cartMetaTotalAmmount = useCartStore(state => state.cartMetaTotalAmmount);

  const [loading, setLoading] = useState<boolean>(cartLoading)

  const nextStepButton = cartMetaTotalCount > 0 ? <Button disabled={loading} loading={loading} onClick={() => { router.push('/cart/checkout'), setLoading(true) }} className={styles.btn}>Checkout</Button> : null

  const containerStyles = [styles.cartWrap]
  if (loading) containerStyles.push(styles.loading)


  return (
    <div className={containerStyles.join(' ')}>
      <div className={styles.cartSummary}>
        <div className={styles.cart}>
          <div className={styles.cartHeader}>
            Order Summary
          </div>        
          <div className={ styles.row }>
            <span>Subtotal {cartMetaTotalCount > 0 ? `(${cartMetaTotalCount} Items):` : ':'}</span>
            <span>£{formatPrice(cartMetaTotalAmmount)}</span>
          </div>        
          <div className={styles.total}>
            <span>Total:</span>
            <span>£{formatPrice(cartMetaTotalAmmount)}</span>            
          </div>
        </div>
        {nextStepButton}
      </div>
    </div>
  )
}